import Layout from '../../../common/components/layout/Layout';

import Header from '../../../common/components/layout/Header';
import { dateList } from '../../../common/data/dateList';
import Filter from '../../../common/components/modules/sports/Filter';
import Loading from '../../../common/loading/Loading';
import { attributesBySport } from '../../../common/data/attributes';

const Filtro = (): JSX.Element => {
    const attribute = attributesBySport('rent');

    return (
        <Layout navProps={{ title: 'Arrienda | Supermatch', description: 'Arrienda Supermatch' }}>
            <>
                <Header />
                {attribute ? (
                    <Filter attribute={attribute} dateList={dateList()} />
                ) : (
                    <div className="flex items-center justify-center lg:h-96 mb:h-96">
                        <Loading />
                    </div>
                )}
                {/* <StepsPlay /> */}
            </>
        </Layout>
    );
};

export default Filtro;
